import Vue, { PropType } from 'vue';
import IconBase from '../icon';
import { IconProps, SVGJson } from '../utils/types';
import useSizeProps from '../utils/use-size-props';

const element: SVGJson = {"tag":"svg","attrs":{"fill":"none","viewBox":"0 0 24 24","width":"1em","height":"1em"},"children":[{"tag":"g","attrs":{"id":"pearl-of-the-orient"},"children":[{"tag":"g","attrs":{"id":"fill1"},"children":[{"tag":"path","attrs":{"fill":"props.fillColor1","d":"M14 6C14 7.10457 13.1046 8 12 8C10.8954 8 10 7.10457 10 6C10 4.89543 10.8954 4 12 4C13.1046 4 14 4.89543 14 6Z"}},{"tag":"path","attrs":{"fill":"props.fillColor1","d":"M15 17C15 18.6569 13.6569 20 12 20C10.3754 20 9 18.6373 9 17C9 15.3431 10.3431 14 12 14C13.6569 14 15 15.3431 15 17Z"}}]},{"tag":"path","attrs":{"id":"stroke1","stroke":"props.strokeColor1","d":"M12 8C13.1046 8 14 7.10457 14 6C14 4.89543 13.1046 4 12 4M12 8C10.8954 8 10 7.10457 10 6C10 4.89543 10.8954 4 12 4M12 8V14M12 4L11.9983 2M12 14C10.3431 14 9 15.3431 9 17C9 17.763 9.25516 18.426 9.75402 18.9889C9.95183 19.2121 10.1824 19.4056 10.4382 19.5619M12 14C13.6569 14 15 15.3431 15 17C15 17.7403 14.7319 18.4179 14.2874 18.9412C14.0801 19.1852 13.8345 19.3956 13.5598 19.5631M10.4382 19.5619L9.00142 22H9L10.4382 19.5619ZM10.4382 19.5619C10.8931 19.8398 11.4279 20 12 20C12.5713 20 13.1053 19.8403 13.5598 19.5631M13.5598 19.5631L14.9986 22H15L13.5598 19.5631Z","strokeLinecap":"square","strokeWidth":"props.strokeWidth"}}]}]};

const PearlOfTheOrient = Vue.extend<IconProps>({
  name: 'PearlOfTheOrientIcon',
  functional: true,
  props: {
    size: {
      type: String,
    },
    onClick: {
      type: Function as PropType<IconProps['onClick']>,
    },
    fillColor: {
      type: [String, Array] as PropType<IconProps['fillColor']>,
    },
    strokeColor: {
      type: [String, Array] as PropType<IconProps['fillColor']>,
    },
    strokeWidth: {
      type: Number,
      default: 2
    }
  },
  render(createElement, context) {
    const { props, data } = context;
    const { size, ...otherProps } = props;

    const { className, style } = useSizeProps(size);
    const fullProps = {
      ...otherProps || {},
      id: 'pearl-of-the-orient',
      icon: element,
      staticClass: className,
      style,
    };
    data.props = fullProps;
    return createElement(IconBase, data);
  },
});

export default PearlOfTheOrient;
